import { useCallback, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import { deleteLocal, setLocal } from '../../utils/api';

import './Splash.css';

function Splash({ authState, confirmConnection, handleError }) {
  const { slug } = useParams();

  const [tenantLabel, setTenantLabel] = useState('Washington State');

  const getTenantData = useCallback(async (slug) => {
    try {
      if (authState?.tenant?.slug === slug) {
        setTenantLabel(authState.tenant.label);
      }
    } catch (e) {
      handleError(e);
    }
  }, [authState, handleError]);

  const handleLogin = useCallback(() => {
    deleteLocal('signup');
    confirmConnection('email');
  }, [confirmConnection]);

  const handleSignup = useCallback(() => {
    setLocal('signup', true);
    confirmConnection('email');
  }, [confirmConnection]);

  useEffect(() => {
    if (slug) {
      getTenantData(slug);
    }
  }, [getTenantData, slug]);

  return (
    <div id="splash">
      <div className="slide">
        <div className="body clamp">
          <div className="guide"></div>
          <div className="guide-title">Your AI Guide</div>
          <div className="guide-description">Pathways AI Guide for {tenantLabel}</div>
          {authState?.type === 'auth0' ? (
            <div className="action action-tertiary" onClick={() => handleSignup()}>First time? Sign up</div>
          ) : null}
        </div>
        <div className="footer clamp">
          <div className="action action-primary" onClick={() => handleLogin()}>Log In</div>
        </div>
      </div>
    </div>
  );
}

export default Splash;
